import { render, staticRenderFns } from "./AssessmentsEdit.vue?vue&type=template&id=287d99b4&scoped=true"
import script from "./AssessmentsEdit.vue?vue&type=script&lang=js"
export * from "./AssessmentsEdit.vue?vue&type=script&lang=js"
import style0 from "./AssessmentsEdit.vue?vue&type=style&index=0&id=287d99b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287d99b4",
  null
  
)

export default component.exports